import { watch } from 'vue'
import { useRouter } from 'vue-router'
import { useAuth } from './auth/useAuth.js'
import { useVersionCheck } from './useVersionCheck.js'
import { loadCategoryColorsFromDB } from '../utils/categoryColors.js'

export function useAppInitialization({ isEmbedRoute, isPublicRoute }) {
  const router = useRouter()
  const { isLoading, checkAuth } = useAuth()
  const { startVersionCheck, stopVersionCheck } = useVersionCheck()

  watch(isPublicRoute, (isPublic) => {
    if (isPublic) {
      isLoading.value = false
    }
  }, { immediate: true })

  const initializeApp = async () => {
    // Wait for router to resolve initial navigation so isPublicRoute is accurate
    await router.isReady()

    if (isEmbedRoute.value || isPublicRoute.value) {
      isLoading.value = false
    } else {
      checkAuth()
      startVersionCheck()
      loadCategoryColorsFromDB()
    }
  }

  const cleanup = () => {
    stopVersionCheck()
  }

  return {
    isLoading,
    initializeApp,
    cleanup
  }
}
